import { Component, OnInit } from '@angular/core';
import { AgrupamentosService } from '../service/agrupamentos.service';
import Swal from 'sweetalert2';
import { VerificarPermissoes } from '../model/verificarPermissoes.model';

@Component({
  selector: 'app-agrupamentos',
  templateUrl: './agrupamentos.component.html',
  styleUrls: ['./agrupamentos.component.css']
})
export class AgrupamentosComponent implements OnInit {

  loader = true;
  agrupamentos = [] as any;

  constructor(
    private agrupamentosService: AgrupamentosService
  ) { }

  ngOnInit(): void {
    if(this.verificarPermissao(['lista_todos_agrupamento'])){
      this.listaAgrupamentos()
    } else {
      this.listarAgrupamentoUsuario();
    }
  }

  listaAgrupamentos(){
    this.agrupamentosService.listarAgrupamento().subscribe((resp:any) => {
      this.agrupamentos = resp
      this.loader = false
    }, err => {
      this.loader = false;
    })
  }


  deletar(idAgrupamento: any) {
    Swal.fire({
      title: 'Desativar agrupamento?',
      showCancelButton: true,
      confirmButtonColor: '#00AA5B',
      cancelButtonColor: '#df4747',
      confirmButtonText: 'Confirmar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.agrupamentosService.deletarAgrupamento(idAgrupamento).subscribe((resp) => {
          Swal.fire(
            '',
            'Deletado com sucesso!',
            'success'
          )
          this.listaAgrupamentos()
        }, err => {
          Swal.fire(
            '',
            'Não foi possível deletar o agrupamento!',
            'error'
          )
        })
      }
    })
  }

  listarAgrupamentoUsuario(){
    this.agrupamentosService.listarAgrupamentoUsuario(localStorage.getItem('usuarioId')).subscribe((resp: any) => {
      this.agrupamentos = resp
      this.loader = false
    }, err => {
      this.loader = false;
    })
  }

  public verificarPermissao(permissoesFuncionalidades: string[]): boolean {
    const permissaoUsuario = localStorage.getItem('permissoes');
    return VerificarPermissoes.temPermissao(permissoesFuncionalidades, permissaoUsuario)
  }

}
